import { StyleSheet } from 'react-native';

import { pt, px, is_android } from '../../common/utils';

export default StyleSheet.create({
    body: {
        flex: 1,
        height: '100%',
        backgroundColor: '#fff'
    },
    row_space_center: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row_center: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    wrap_confirm_text: {
        minHeight: pt(70),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    wrap_alert_text: {
        minHeight: pt(20),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    confirm_text: {
        color: '#232326',
        textAlign: 'center',
        fontSize: pt(14),
        lineHeight: pt(20)
    },
    showReason: {
        fontSize: pt(14),
        lineHeight: pt(25),
        textAlign: 'center'
    },
    column_center: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    container: {
        flex: 1,
        backgroundColor: '#fff'
    },
    content_wrap: {
        paddingTop: pt(10)
    },
    // input输入框
    input_box: {
        marginBottom: pt(21),
        height: pt(36)
    },
    input: {
        flex: 1,
        padding: 0,
        paddingLeft: pt(20),
        paddingRight: pt(20),
        height: pt(36),
        borderRadius: pt(6),
        backgroundColor: '#eee',
        fontSize: pt(12)
    },
    add_btn: {
        marginLeft: pt(20),
        width: pt(70),
        height: pt(36),
        borderRadius: pt(6)
    },
    add_btn_isweb: {
        marginLeft: pt(20),
        width: pt(70),
        height: pt(36),
        borderRadius: pt(6),
        overflow: 'hidden'
    },
    scroll_view: {
        paddingHorizontal: pt(20)
    },

    dash_box: {
        height: pt(150)
    },
    gray_img: {
        height: '100%',
        width: '100%'
    },

    bottom: {
        paddingVertical: pt(13),
        paddingHorizontal: pt(20),
        borderTopWidth: pt(1),
        borderTopColor: '#ddd'
    },
    bottom_btn: {
        height: pt(40),
        borderRadius: pt(6),
        backgroundColor: '#2936d7'
    },
    showReason: {
        fontSize: pt(14),
        lineHeight: pt(25),
        textAlign: 'center'
    },
    confirm_text: {
        color: '#232326',
        textAlign: 'center',
        fontSize: pt(14),
        lineHeight: pt(20)
    },
    wrap_confirm_text: {
        minHeight: pt(70),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    confirm_text: {
        color: '#232326',
        textAlign: 'center',
        fontSize: pt(14),
        lineHeight: pt(20),
        paddingVertical: pt(12)
    },
    showReason: {
        fontSize: pt(14),
        lineHeight: pt(25),
        textAlign: 'center',
        paddingVertical: pt(12)
    }

    // pop: {
    //     backgroundColor: 'rgba(0,0,0,.5)'
    // },
    // pop_inner: {
    //     width: pt(250),
    //     height: pt(320),
    //     borderRadius: pt(8),
    //     backgroundColor: '#fff'
    // },
    // pop_img_box: {
    //     width: pt(140),
    //     height: pt(163)
    //     // borderWidth: pt(1),
    //     // borderStyle: 'dashed',
    //     // borderColor: '#525151'
    // },
    // pop_img: {
    //     width: '100%',
    //     height: '100%'
    // },
    // pop_text: {
    //     marginVertical: pt(20),
    //     fontSize: pt(20),
    //     color: '#181818'
    // },
    // confirm_btn: {
    //     width: pt(170),
    //     height: pt(46),
    //     borderRadius: pt(23),
    //     backgroundColor: '#2936d7',
    // }
});
